import { useState } from 'react';
export function useTwoFactorSelect({ onSelect, onContinue, loading = false, error = null, }) {
    const [selected, setSelected] = useState('');
    const [showInlineError, setShowInlineError] = useState(true);
    const handleSelect = (value) => {
        setSelected(value);
        onSelect(value);
    };
    const handleContinue = () => {
        setShowInlineError(true);
        onContinue();
    };
    return {
        selected,
        handleSelect,
        handleContinue,
        loading,
        error,
        showInlineError,
        setShowInlineError,
    };
}
